export const getTransitDays = (expectedDelivery, vehicleRequirement) => {
  return Math.round((expectedDelivery - vehicleRequirement) / (24 * 60 * 60 * 1000)) + 1;
}
